
export function readMoreString(content, length) {
  if (content.length > length) {
    return content.substring(0, length) + '...'
  }
  return content
}

export function truncateFilenameKeepExtension(filename, length) {
  if (filename) {
    let extensionIndex = filename.lastIndexOf(".")
    let filenameNoExtension = filename.substring(0, extensionIndex)
    var fileExt = filename.split('.').pop();
    if (length && filenameNoExtension.length > length) {
      return filenameNoExtension.substring(0, length - fileExt.length) + '...' + fileExt
    }
    return filename
  }
  return null;
}

const FILENAME_PREPEND_LENGTH_CHARACTERS = 14

export function getFilenameFromMediaUrl(mediaUrl) {
  return mediaUrl
    .substring(mediaUrl.lastIndexOf("/") + 1)
    .substring(FILENAME_PREPEND_LENGTH_CHARACTERS);
}

export function getTruncatedFilenameWithExtensionFromMediaUrl(mediaUrl, length) {
  return truncateFilenameKeepExtension(getFilenameFromMediaUrl(mediaUrl), length)
}